import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {

    
    
	
	
   if(sessionStorage.getItem("PlusingRtn_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    setId("{Auto}");
    
	//Clear();
   
   }
   else if(sessionStorage.getItem("PlusingRtn_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("PlusingRtn_EditId"));
   }
   else if(sessionStorage.getItem("PlusingRtn_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("PlusingRtn_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  GetGrnDetails1();
  }

  
  const [dtGrnDetails, setdtGrnDetails]=useState([]);
  const [dtGrnDetailsOrg, setdtGrnDetailsOrg]=useState([]);
  
  
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  


   const [LotNo, setLotNo, LotNoRef] = useStateRef(0);
   const [GrnNo, setGrnNo, GrnNoRef] = useStateRef(0);
   const [Remarks, setRemarks, RemarksRef] = useStateRef('');
   const [LotDate, setLotDate, LotDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   const [Id, setId, IdRef] = useStateRef(0);
   const [Pcs, setPcs, PcsRef] = useStateRef(0);
   const [GrossWt, setGrossWt, GrossWtRef] = useStateRef(0);
   const [BWt, setBWt, BWtRef] = useStateRef(0);
   
   const [SearchTxt, setSearchTxt, SearchTxtRef] = useStateRef('');

 



function SearchFun(text)
{
  setdtGrnDetails(dtGrnDetailsOrg.filter(function (x) {
    return x.LotNo.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  

 
  async function Clear()
   {
    
    setPcs(0);
    setGrossWt(0);
		setId("{Auto}");
    setLotNo(0);
    setGrnNo(0);
    setRemarks('');
    setBWt(0);

		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



async function Calc()
{
  
  
  if(val(GrossWtRef.current)>val(BWtRef.current))
  {
    let DiffWt=val(GrossWtRef.current)-val(BWtRef.current);
    swal({
      title: "",
      text: "The Weight Difference : " + DiffWt,
      icon: "info",
      button: "Ok"
    
    });
    
    setGrossWt(0);
    
    return;
  }
  else
  {
    
  }








}


async function ControlSettings()
{

  document.getElementById("txtLotNo").disabled ='true';
  
  
  if((sessionStorage.getItem("PlusingRtn_Action")=="Edit") || (sessionStorage.getItem("PlusingRtn_Action")=="Delete"))
   {
  
   
   }
}



async function GetGrnDetails1()
{
  try
  {
   
    let postData = {
      "BranchCode":sessionStorage.getItem("BranchCode")
  }

  const results = await apiService.postCall("plusingrtn/GetGrnDetails1",postData);

 if (results != "-1") {
   setdtGrnDetails(results.data[0]);
   setdtGrnDetailsOrg(results.data[0]);
 }

  
  }
  catch (error) {
    console.log(error);
  }
}


async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }

    const results = await apiService.postCall("plusingrtn/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;


   getLookup();

   setLotNo(HeadData[0][0].IssueNo);
   setLotDate(HeadData[0][0].RDate.substring(0,10));
   setId(HeadData[0][0].RNo);
   setGrnNo(HeadData[0][0].GrnNo);
   
   setPcs(HeadData[0][0].Pcs);
   setGrossWt(val(HeadData[0][0].GrossWt).toFixed(2));
   setRemarks(HeadData[0][0].Remarks);
   
   setBWt(results.data.BWt);
   

   
   await Calc();

   }

    
    }
    catch (error) {
      console.log(error);
    }

  }

  async function Err(msg)
  {
 
        swal({

          title: "",
          text: msg,
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
  }


async function Save(){
	  try
		{
	
		// validation start
		
  
    if(LotNoRef.current=="0")
    {
      await Err("Please Select Lot No");
      return;
    }

   

   
    if(val(PcsRef.current)=="0")
    {
      await Err("Enter Pcs");
      return;
    }

    if(val(GrossWtRef.current)=="0")
    {
      await Err("Enter GrossWt");
      return;
    }

    
      

      // validation end


      

		 
		let postData = {
			"Action" : sessionStorage.getItem("PlusingRtn_Action"),
			"EditId" : sessionStorage.getItem("PlusingRtn_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
		  "LotNo":LotNoRef.current,
      "LotDate":LotDateRef.current,
      "GrnNo":GrnNoRef.current,
      "Pcs":PcsRef.current,
      "GrossWt":GrossWtRef.current,
      "Remarks": RemarksRef.current,
     
    }

    
    
 
   const results = await apiService.postCall("plusingrtn/Save",postData);



   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    return;
  });

  return;

}  




  if(sessionStorage.getItem("PlusingRtn_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("PlusingRtn_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("PlusingRtn_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }

  async function setCheck(id)
  {

    try
  {
   
   
  
    let postData = {
      "IssueNo": id,
      "Id":IdRef.current
  }

  const results = await apiService.postCall("plusingrtn/GetGrnDetails",postData);

 if (results != "-1") {
  
  let data=results.data[0];
  
  setLotNo(data[0][0].IssueNo);
  setGrnNo(data[0][0].GrnNo);
  setGrossWt(val(data[0][0].BWt).toFixed(2));
  setPcs(data[0][0].BPcs);
  setBWt(val(data[0][0].BWt).toFixed(2));
  
 
 }

 setTMShow1(false);

  
  }
  catch (error) {
    console.log(error);
  }
}

  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : ""
    };
		
    const results = await apiService.postCall("plusingrtn/Lookup",postData);

	 if (results != "-1") {  
      
  }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/plussing/plusingrtn/list');
  };

  return (
    <>
    

      <Row className="">
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">Plussing Return Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
             
                 


                  <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-4'>

                        <div className='col-md-4'>
                            <Form.Label><a onClick = {(e) => {
                              if(sessionStorage.getItem("PlusingRtn_Action")=="Add")
                             { setTMShow1(true)}

                              }} href="#">Lot No</a></Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtLotNo" placeholder="" value={LotNo}  />
                          </div>

                          <div className='col-md-6'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" disabled="disabled" id="txtLotDate" placeholder="" value={LotDate} onChange={(e)=>setLotDate(e.target.value)} />
                          </div>
                        
                          <div className='col-md-4'>
                            <Form.Label>Rtn No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" disabled="disabled" id="txtTagId" placeholder="" value={Id} onChange={(e)=>setId(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text"  id="txtPcs" placeholder="" value={Pcs} onChange={(e)=>setPcs(e.target.value)} />
                          </div>

                          <div className='col-md-4'>
                            <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text" id="txtGrossWt" placeholder="" value={GrossWt} 
                            onChange={(e)=>{setGrossWt(e.target.value)
                            }
                          } onBlur={Calc} />
                          </div>

                          <div className='col-md-12'>
                            <Form.Label>Remarks</Form.Label>
                            <Form.Control type="text"  id="txtRemarks" placeholder="" value={Remarks} onChange={(e)=>setRemarks(e.target.value)} />
                          </div>
                        

   </div>
	  </div>
</div>

</div>


 

</div>
                  
              </div>
             

        
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg"  id ="otherlotentrytableModal" >
                  <Modal.Header closeButton>
                    <Form.Control type="text" placeholder='Search' value={SearchTxt} onChange={(e)=> { 
                      setSearchTxt(e.target.value)
                      SearchFun(e.target.value)
                      }}/>
                  </Modal.Header>

                  <Modal.Body>
                    
                                 
              <div className="table-responsive mt-4" id="otherlotentrytable1" >
			 
				
       <Table striped id="table-basic" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>Issue No</th>
             <th>GRN No</th>              
             <th>Pcs</th>              
             <th>Weight</th>              
             
           </tr>
         </thead>
         <tbody>
         {dtGrnDetails.map((item) => (
           <tr>
            
   <td>  
    
     <Form.Check className="me-2">
                               
                               <Form.Check.Input type="radio" name="g1" onChange={(e) => setCheck(item.IssueNo)} checked={item.checked} className="lstItems" id={item.IssueNo} />
                               
                               <Form.Check.Label>{item.IssueNo}</Form.Check.Label>
                             </Form.Check>
                             </td>
         
             
             <td>{item.GrnNo}</td>
             <td>{item.BPcs}</td>
             <td>{item.BWt.toFixed(2)}</td>
            


           </tr>
             )
             )
              }     
         </tbody> 
       </Table>
      
     </div>

					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
